/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

//设置登录信息
const setLoginInfo = ({dispatch, state}, loginInfo) => {
	return dispatch('SET_LOGININFO', loginInfo);
}

module.exports = {
  setLoginInfo
}



// WEBPACK FOOTER //
// ./src/appBackend/vuex/action/login.js